








/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// getAuthUserById
// GETAUTHUSERBYID
const GETAUTHUSERBYID= createAsyncThunk(
  "getAuthUserById/getAuthUserById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAuthUserByIdSlice = createSlice({
  name: "getAuthUserByIdSlice",
  initialState: {
    getAuthUserById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAuthUserById: (state) => {
        state.getAuthUserById.loading = false
        state.getAuthUserById.error = false
        state.getAuthUserById.data = []
        state.getAuthUserById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETAUTHUSERBYID.fulfilled, (state, action) => {
      state.getAuthUserById = {
        ...state.getAuthUserById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAUTHUSERBYID.pending, (state, action) => {
      state.getAuthUserById = {
        ...state.getAuthUserById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAUTHUSERBYID.rejected, (state, action) => {
      state.getAuthUserById = {
        ...state.getAuthUserById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAuthUserByIdAction = {
    GETAUTHUSERBYID,
};

export { getAuthUserByIdAction };
export default getAuthUserByIdSlice.reducer;
export const {setInitialStateOfgetAuthUserById} = getAuthUserByIdSlice.actions
